import styled from "styled-components";

import DefaultCheckbox from "components/Form/Input/Checkbox";
import { withStyledContainer } from "utils/styled";

export const SubHeader = styled.h3`
  font-size: 18px;
  margin-bottom: 16px;
`;

export const Checkbox = withStyledContainer(DefaultCheckbox)`
  margin-bottom: 20px;
`;
